import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {
    RegistrationEmailOnlyReq,
    RegistrationResponse
} from '../protocol/registration-req';

export class RegistrationEmailOnly extends HubApiRequest<RegistrationEmailOnlyReq, RegistrationResponse> {
    constructor(url: string, deviceIdentifier: string, data: RegistrationEmailOnlyReq) {
        super(url, HubMethod.REGISTRATION_WITH_EMAIL_ONLY, deviceIdentifier, data, uuidv4());
    }
}
